module.exports = __webpack_public_path__ + "static/img/v4_2.69f354f8.png";